import axios from 'axios';
import store from '@/store/index'
const request = {
    token: {},
    async get(apiurl, params = {}, anonymous = false) {
        return await this.servicerequest(process.env.VUE_APP_API_PATH + apiurl, 'GET', params, anonymous)

    },
    async post(apiurl, data = {}, anonymous = false) {
        return await this.servicerequest(process.env.VUE_APP_API_PATH + apiurl, 'POST', data, anonymous, false)
    },
    async postFile(apiurl, data = {}, anonymous = false) {
        return await this.servicerequest(process.env.VUE_APP_API_PATH + apiurl, 'POST', data, anonymous, true)
    },
    async exportFile(apiurl, data = {}, anonymous = false) {
        return await this.servicerequest(process.env.VUE_APP_API_PATH + apiurl, 'POST', data, anonymous, false, true)
    },
    async put(apiurl, data = {}, anonymous = false) {
        return await this.servicerequest(process.env.VUE_APP_API_PATH + apiurl, 'PUT', data, anonymous, false)
    },
    async servicerequest(apiurl, method = 'GET', parameter = {}, anonymous = false, file = false, arrayBuffer = false) {
        this.token = localStorage.getItem("token");
        if (!anonymous) {
            store.dispatch("showServiceLoader", true);
            if (!this.token) {
                store.dispatch("showValidationMessage", { message: "Session Expired", color: "red accent-2" });
                store.dispatch("logout")
                store.dispatch("showServiceLoader", false);
                localStorage.clear()
                location.href = "#/login"
                return
            }
            let t = JSON.parse(atob(this.token.split('.')[1]))
            if (new Date() > new Date(t.exp * 1000)) {
                store.dispatch("showValidationMessage", { message: "Session Expired", color: "red accent-2" });
                store.dispatch("showServiceLoader", false);
                store.dispatch("logout")
                localStorage.clear()
                location.href = "#/login"
                return
            }
        }
        var headers = { 'X-Requested-With': 'XMLHttpRequest' }
        if (!anonymous && this.token) {
            headers = { Authorization: `Bearer ${this.token}` }
        }
        if (!file && (typeof parameter == "string" || typeof parameter == "number")) {
            headers["Content-Type"] = "application/json"
        }
        if (file) {
            headers["Content-Type"] = "multipart/form-data"
        }
        let responseType = 'json';
        if (arrayBuffer) {
            responseType = 'arraybuffer';
        }
        let params = {}
        if (method == 'GET')
            params = parameter
        try {
            let response = await axios({
                method: method,
                url: apiurl,
                data: parameter,
                headers: headers,
                params: params,
                responseType: responseType
            })
            store.dispatch("showServiceLoader", false);
            if (response && response.headers && response.headers.token) {
                this.token = response.headers.token
                localStorage.setItem("token", this.token);
            }

            if (response.status == 401) {
                store.dispatch("logout")
                localStorage.clear()
                location.href = "#/login"
                return
            } else {
                return response
            }
        }
        catch (err) {
            store.dispatch("showServiceLoader", false);
            if (err && (err.response == undefined)) {
                if (navigator.onLine) {
                    store.dispatch("showValidationMessage", { message: "Unable to reach the server at this point of time, please try again later...", color: "red accent-2" });
                    return
                } else {
                    store.dispatch("showValidationMessage", { message: "Network disconnected, please check your internet and try again.", color: "red accent-2" });
                    return
                }
            }
            else if (err.response.status == 401) {
                store.dispatch("logout")
                localStorage.clear()
                location.href = "#/login"
                return
            }
            else if (err.response.status == 403) {
                store.dispatch("showValidationMessage", { message: "You DON'T have access to this resource", color: "red accent-2" });
                return
            } else if (err.response.status < 500) {
                return err.response
            }
            else if (err.response.status == 500) {
                store.dispatch("showValidationMessage", { message: "Something went wrong, Please try again later...", color: "red accent-2" });
            }
        }
    }
}

window.updateToken = function (token) {
    localStorage.setItem("token", token)
    window._user.Token = token
    request.token = token
}

export default request